module.exports = __webpack_public_path__ + "img/dote-alvalade.5da2af22.jpg";